import { FC, ReactNode } from "react";
import { useController } from "react-hook-form";
import type { UseControllerProps } from "react-hook-form";
import { Flex, Typography } from "@payping/web-components";
import { InputNumber } from "@payping/web-components/components/input-number";
import type { InputNumberProps } from "@payping/web-components/components/input-number";
import { numberFormatter } from "@payping/utilities-shared/number";

type Props = InputNumberProps &
  UseControllerProps<any> & {
    label?: ReactNode | string;
    labelClassName?: string;
  };

const RHFInputNumber: FC<Props> = ({
  name,
  control,
  defaultValue = "",
  rules,
  shouldUnregister,
  label,
  labelClassName,
  ...rest
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <Flex vertical className="tw:relative tw:pb-[28px]!">
      {label && <Typography.Text className={`tw:mb-[8px]! tw:text-[14px]! ${labelClassName}`}>{label}</Typography.Text>}
      <InputNumber
        formatter={(value) => numberFormatter.format(value, { maxDecimals: 0 })}
        parser={(value) => numberFormatter.parse(value)}
        {...field}
        {...rest}
        status={error ? "error" : ""}
      />
      {error && (
        <Typography.Text type="danger" className="tw:absolute tw:bottom-[2px] tw:start-0">
          {error.message}
        </Typography.Text>
      )}
    </Flex>
  );
};

export default RHFInputNumber;
